<template>
  <div class="fraud">
    <keep-alive>
        <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'fraud',
  data() {
    return {
      submitData: {
        moneyLoss: '', //损失金额
        userRole: '', //用户角色
        tradingChannel: '', //交易渠道
        chooseType: '', //勾选证据类型 1商品2私信3订单
        chooseEvidence: '', //1 商品是商品id 2 私信是私信内容 3 订单是订单id  多个用逗号分割
        questionId: '', //选择的问题id
        questionDesc: '', //选择的问题
        productCategory: '', //手机或非手机
        content: '', //凭证描述 多个用逗号分割
        pics: '', //凭证照片和视频 json数组
        outsideCommunication: '', // 是否有站外沟通 0没有 1有  不选传null
        outsidePic: '', //站外沟通凭证照片 json数组
        guideContent: '', //引导描述
        phoneQuestionDesc: '' //手机品类问题描述
      }
    }
  },
  provide() {
    return {
      submitData: this.submitData,
      files2PicAndVideo: this.files2PicAndVideo, //转换方法
      mergeSubmitData: this.mergeSubmitData //合并提交数据方法
    }
  },
  methods: {
    mergeSubmitData(params = {}) {
      Object.assign(this.submitData, params)
    },
    files2PicAndVideo(array = []) {
      return array.map(t => {
        if (/image/g.test(t.type)) {
          return t.url
        }
        if (/video/g.test(t.type)) {
          return {
            picUrl: t.response,
            videoUrl: t.url
          }
        }
        return ''
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "index.less";
</style>